import React from 'react'
import moment from 'moment'

import NotificationsPopup from './NotificationsPopup.js'
import NotificationContent from './NotificationContent.js'
import {Card, Caption, Colors, P, H6, ScrollView} from '../UI/index.js'
import {getNotificationFirstLine, sortNotificationsByScheduled} from '../../../utils/notifications.js'
import t from '../../helpers/Languages.js'

class NotificationsPage extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            checkedNotifications: false,
            selectedId: null
        }
    }

    componentDidMount() {
        const {notifications} = this.props
        if (notifications) {
            this.notificationsPopup?.checkIfNewNotification(true)
            this.setState({checkedNotifications: true})
        }
    }

    componentDidUpdate(prevProps) {
        const {checkedNotifications} = this.state
        const {notifications} = this.props

        if (notifications?.toString !== prevProps.notifications?.toString() && !checkedNotifications) {
            this.notificationsPopup?.checkIfNewNotification(true)
        }
    }

    renderList() {
        const {notifications} = this.props
        const {selectedId} = this.state

        const sortedNotifications = sortNotificationsByScheduled(notifications || [])

        if (!sortedNotifications.length) {
            return (
                <div style={{marginTop: 100, textAlign: 'center'}}>
                    <P>{t('noNotifications')}</P>
                </div>
            )
        }

        // Without a selection (or when it is gone) the newest notification is opened
        const selectedNotification = sortedNotifications.find((notification) => notification._id === selectedId) || sortedNotifications[0]

        return (
            <div style={{display: 'flex', flex: 1, minHeight: 0, gap: 24, padding: 24}}>
                <Card style={{width: 720, flex: 'none', display: 'flex', flexDirection: 'column', padding: 0, overflow: 'hidden'}}>
                    <ScrollView>
                        {sortedNotifications.map((notification) => {
                            const selected = notification._id === selectedNotification._id

                            return (
                                <div
                                    key={notification._id}
                                    style={{
                                        padding: 12,
                                        cursor: 'pointer',
                                        flexShrink: 0,
                                        background: selected ? Colors.backgroundSelected : Colors.backgroundWhite,
                                        borderBottom: `1px solid ${Colors.grey20}`
                                    }}
                                    onClick={() => this.setState({selectedId: notification._id})}
                                >
                                    <H6 style={{marginBottom: 12, color: Colors.textDark}} ellipsis>{notification.title}</H6>
                                    <Caption>{moment(notification.scheduleDate).format('DD-MM-YYYY')}</Caption>
                                    <P ellipsis style={{marginTop: 4, color: Colors.textMedium}}>{getNotificationFirstLine(notification.message)}</P>
                                </div>
                            )
                        })}
                    </ScrollView>
                </Card>

                <Card style={{display: 'flex', flexDirection: 'column', padding: 0, overflow: 'hidden', width: 'fit-content'}}>
                    <ScrollView style={{padding: 24}}>
                        <div style={{maxWidth: 800}}>
                            <NotificationContent
                                showTitle
                                notification={selectedNotification}
                                subtitle={<Caption style={{marginBottom: 12}}>{moment(selectedNotification.scheduleDate).format('DD-MM-YYYY')}</Caption>}
                            />
                        </div>
                    </ScrollView>
                </Card>
            </div>
        )
    }

    render() {
        const {user, notifications, showList} = this.props

        if (showList) {
            return this.renderList()
        }

        return (
            <div style={{marginTop: 100}}>
                <Card style={{maxWidth: 600, margin: 'auto', padding: 24}}>
                    <NotificationsPopup
                        showAll
                        user={user}
                        notifications={notifications}
                        ref={(ref) => this.notificationsPopup = ref}
                    />
                </Card>
            </div>
        )
    }
}

export default NotificationsPage
